import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { resolveItemImage } from "@/helpers/itemImage"
import { rarityStyle } from "@/helpers/rarity"
import styles from "./EquipmentSlotCell.module.scss"
import { IEquipmentSlotCellProps } from "./types"

export const EquipmentSlotCell: FC<IEquipmentSlotCellProps> = ({
  item,
  position,
  onClick
}) => {
  const { t } = useTranslation("inventory")
  const image = item ? resolveItemImage(item.definitionCode) : undefined
  return (
    <button
      type="button"
      disabled={!item || !onClick}
      className={clsx(styles.EquipmentSlotCell, {
        [styles.empty]: !item,
        [styles.inactive]: item?.inactive
      })}
      onClick={() => onClick?.(position)}
      style={rarityStyle(item)}
    >
      {item &&
        (image ? (
          <img
            className={styles.EquipmentSlotCell_icon}
            src={image}
            alt={t(`item.${item.definitionCode}.name`)}
            loading="lazy"
          />
        ) : (
          <span className={styles.EquipmentSlotCell_name}>
            {t(`item.${item.definitionCode}.name`)}
          </span>
        ))}
    </button>
  )
}
